export default {
  title_open_issues_on_item: "Issues",
  title_unsubmitted_work_issues: "Regular Work with raised Issues",
  text_more_than_one_issue:
    'Select from the  <b class="text-info">Issues</b> or go to the filtered <b class="text-info">Issues</b> list!',
  text_raised_issues:
    'You have raised <b>{count}</b> <b class="text-info">Issues</b> for this <b class="text-info">Performed Work</b>.',
  text_proceed: "How do you wish to proceed?",
}
